// DEV-401 — never-block public checkout (deferred invoice) frontend flag.
//
// Backend contract: paworld-content-api issue #401, draft PR #403, branch
// feat/checkout-neverblock-deferred-invoice (ENABLE_CHECKOUT_NEVERBLOCK).
//
// When OFF (the default, and the only deployed state today) every DEV-401
// behaviour is inert and the legacy buyerLinked gate + legacy invoice
// assumptions are preserved byte-for-byte.
//
// When ON:
//   - Dataverse buyerLinked/contactLinked becomes diagnostic only and can no
//     longer block Continue, acceptance capture, Pay or a safe retry;
//   - the Order Hub is driven by backend action descriptors rather than by
//     CHECKOUT_PREVIEW_CONFIRM_ENABLED;
//   - deferred `order_from_checkout:cs_<opaque>` Order keys are accepted.
//
// This flag NEVER independently enables payment. CHECKOUT_STAGE2_API_ENABLED
// and CHECKOUT_PAYMENT_ENABLED remain mandatory and are checked separately —
// see CheckoutFormStage2's paymentCtaAllowed and CheckoutReturnPage's
// retryEligible.
//
// Read at module scope, matching the fail-closed idiom used by
// CHECKOUT_STAGE2_API_ENABLED / CHECKOUT_PAYMENT_ENABLED in stage2Api.ts:
// anything other than the exact string "true" is false. Tests override it by
// spreading `vi.importActual` and replacing the const, not via vi.stubEnv.
export const CHECKOUT_NEVERBLOCK_ENABLED =
  String(import.meta.env.VITE_ENABLE_CHECKOUT_NEVERBLOCK ?? "false").toLowerCase() === "true";
